import angular from 'angular';
import ngCookies from 'angular-cookies';
import localStorage from 'angular-local-storage';
import {AuthComponent} from './auth.component.js';
import {djangoAuth} from './auth.service.js';

const auth = angular.module('auth', [ngCookies, localStorage]);

auth.service('djangoAuth', djangoAuth);
auth.component('auth', AuthComponent);

export {auth};




// WEBPACK FOOTER //
// ./app/components/auth/auth.js